import React from 'react';
import { MapPin } from 'lucide-react';

export const EmptyState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <MapPin size={32} className="text-gray-400" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        Лакацыі не знойдзены
      </h3>
      <p className="text-gray-600 max-w-sm">
        Паспрабуйце змяніць параметры фільтрацыі або павялічыць радыус пошуку
      </p>
    </div>
  );
};